import styled from 'styled-components';
import colors from '../../styles/colors';

export const Bills = styled.div`
    .multiplusContainers{
        display: block;
    }
    .containerBLock{
        width: calc(100% - 60px)
    }
    .topoBills{
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: 90px;
    }

    .btnsTopoBills{
        display: flex;
        column-gap: 20px;

        a{
            white-space: nowrap;
            align-items: center;
        }
    }

    .listDatasBoletos{
        margin: 0 30px;
        list-style: none;
        padding: 0;
        display: flex;
        column-gap: 8px;

        li{
            flex: 1;

            button{
                border: 1px solid #E6E6E6;
                box-sizing: border-box;
                border-radius: 5px 5px 0 0;
                background: rgba(white, .5);
                transition: all .15s;
                font-size: 14px;
                line-height: 21px;
                color: ${colors.mediumGray};
                padding: 9px 9px 7px 9px;
                text-align: center;
                width: 100%;
                position: relative;

                &:not(.active){
                    &:after{
                        content: "";
                        width: 100%;
                        height: 10px;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        background-color: transparent; /* For browsers that do not support gradients */
                        background-image: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,.2));
                        opacity: 0.3;
                    }
                }


                &:hover{
                    padding: 11px 15px;
                    margin-top: -5px;
                }

                &.active{
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 19px;
                    border-bottom: 3px solid ${colors.primary};
                    color: ${colors.primary};
                    box-shadow: 0px 2px 14px rgb(0 0 0 / 12%);
                    background: white;
                    padding: 11px 15px;
                    margin-top: -5px;
                }
            }
        }
    }
    .descricaoTable{

        &.hide{
            display: none;
        }
        &.show{
            display: table-row;
        }
    }

    .buscaBills{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .-busca{
            h3{
                font-weight: 500;
                font-size: 20px;
                line-height: 24px;
                color: ${colors.boldGray};
                margin: 0 0 15px 0;
            }

            input{
                width: 340px;
                border: 1px solid ${colors.buttonBorder};
                border-radius: 4px;
            }

            svg{
                position: absolute;
                top: 6px;
                right: 9px;
                
                path{
                    fill: ${colors.primary};
                }
            }

            ::-webkit-input-placeholder { /* Edge */
                font-size: 14px;
                line-height: 21px;
                color: ${colors.btnDisabledPrimary};
            }
            
            :-ms-input-placeholder { /* Internet Explorer 10-11 */
                font-size: 14px;
                line-height: 21px;
                color: ${colors.btnDisabledPrimary};
            }
            
            ::placeholder {
                font-size: 14px;
                line-height: 21px;
                color: ${colors.btnDisabledPrimary};
            }
        }

        .--previsao{
            mix-blend-mode: normal;
            border-radius: 4px;
            padding: 12px 8px;
            background: rgba(${colors.buttonBorderRGB}, .5);

            h4{
                font-weight: 500;
                font-size: 14px;
                line-height: 17px;
                margin: 0 0 5px 0;
                color: ${colors.boldGray};
            }

            p{
                font-weight: normal;
                font-size: 14px;
                margin: 0;
                line-height: 21px;
                display: flex;
                justify-content: space-between;
                column-gap: 66px;
                color: ${colors.boldGray};
            }
        }
    }
    table{
        thead{
            background: rgba(${colors.theadBg}, 0.08);
        }
    }
    .btnVertabela{
        border: none;
        background: none;
        font-size: 14px;
        line-height: 21px;
        text-decoration-line: underline;
        color: ${colors.primary};

        svg{
            transition: all .35s;
            width: 10px;
            margin-left: 4px;
            path{
                fill: ${colors.primary};
            }
        }

        &.show{
            svg{
                transform: rotate(180deg);
            }
        }
    }

    .vermaisDescricao{
        background: rgba(${colors.theadBg}, 0.08);
        
        p{
            padding: 10px 0;
            font-size: 12px;
            line-height: 21px;
            margin: 0;
            color: ${colors.mediumGray};

            b{
                font-weight: 500;
                color: ${colors.boldGray};
            }
        }
    }
    .btnsAcoes{
        display: flex;
        justify-content: flex-end;
        column-gap: 10px;

        .dropdown-toggle::after{
            display: none;
        }

        .btnDrop{
            
            svg{
                margin: 0;

            }

            

            &:hover, &:focus, &:active{
                background: ${colors.btnHoverPrimary} !important;
                border:1px solid  ${colors.btnHoverPrimary} !important;
                color: ${colors.primary} !important;

                svg{
                    path{
                        fill: ${colors.primary} !important;
                    }
                }
            }
        }

        
    }
    .tdAcoes{
        overflow: inherit !important;

        .dropdown-item{
            font-size: 12px;
            line-height: 21px;
            padding: 6px 8px;
            color: ${colors.boldGray};

            &:hover{
                background: ${colors.buttonBorder};
            }
        }
    }

    .gehEtv .btn-primary:not(:disabled):not(.disabled).active, .gehEtv .btn-primary:not(:disabled):not(.disabled):active, .gehEtv .show>.btn-primary.dropdown-toggle{
        border:1px solid  ${colors.btnHoverPrimary} !important; 
        
    }
`;